import type { AxiosResponse, InternalAxiosRequestConfig } from 'axios'

import { camelizeKeys, decamelizeKeys } from 'humps'

import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_APP_API_BASE_URL
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
api.interceptors.request.use((request: InternalAxiosRequestConfig<any>) => {
  if (request.data) {
    request.data = decamelizeKeys(request.data)
  }

  return request
})

api.interceptors.response.use((response: AxiosResponse) => {
  if (
    response.data ||
    response.headers['content-type'] === 'application/json'
  ) {
    response.data = camelizeKeys(response.data)
  }

  return response
})
